import { setOpenLocationSelectionModal } from '@/store/modal';
import { openSearchModal } from '@/store/search/search.store';
import { PersistedUserNavigationSearchParams } from '@/types/enums/persisted-user-navigation-search-params.enum';

interface HandleOpenSearchModalProps {
  searchTerm?: string | undefined;
}

export function handleOpenSearchModal({ searchTerm }: HandleOpenSearchModalProps = {}) {
  const searchParams = new URLSearchParams(window.location.search);
  const city = searchParams.get(PersistedUserNavigationSearchParams.CIDADE);

  if (city) {
    openSearchModal(true, searchTerm);
  } else {
    if (searchTerm) {
      setOpenLocationSelectionModal(true, {
        shouldOpenSearchModal: false,
        pendingSearchTerm: searchTerm,
      });
    } else {
      setOpenLocationSelectionModal(true, {
        shouldOpenSearchModal: false,
      });
    }
  }
}
